/**add a function to be called this page finishes loading.  If the window already
 has an onload function then the new function will be called
 before or after the existing (depending 'prepend' parameter).
 */
export function addWindowOnLoadHandler(aFunction, prepend) {
    //does form have onload handler yet?
    if (window.onload) {
        //add the hooks array to the form object if necessary
        if (!window.onLoadHooks) {
            //first handler will be the current onload function

            //the original onload function must remain as a member of the form object
            // so that references to 'this' are evaluated correctly.
            window.orig_onload = window.onload;
            window.onLoadHooks = [function () {
                return window.orig_onload();
            }];

            //new onload is our helper function
            window.onload = doHookedFormLoad;
        }

        if (prepend) {
            //tack on another function to the FRONT of the array
            window.onLoadHooks.unshift(aFunction);
        } else {
            //tack on another function to the BACK of the array
            window.onLoadHooks.push(aFunction);
        }
    } else { //else this is the first one so just call it directly (less overhead)
        window.onload = aFunction;
    }
}

function doHookedFormLoad() {
    //call all hooks
    for (let i = 0; i < this.onLoadHooks.length; i++)
        this.onLoadHooks[i]();

    //all hooks returned true - continue with the submission.
    return true;
}// Returns the height of the containg frame or window or -1 if it could not be determined
export function getCursorPosition(e) {
    e = e || window.event;
    let cursor = {x: 0, y: 0};
    if (e.pageX || e.pageY) {
        cursor.x = e.pageX;
        cursor.y = e.pageY;
    } else {
        let de = document.documentElement;
        let b = document.body;
        cursor.x = e.clientX +
            (de.scrollLeft || b.scrollLeft) - (de.clientLeft || 0);
        cursor.y = e.clientY +
            (de.scrollTop || b.scrollTop) - (de.clientTop || 0);
    }
    return cursor;
}

export function calculateLeftPosition(menuElm, containerWidth, cursorX, treeWidth, offsetLeft) {
    if ((containerWidth * 0.85) > cursorX) {
        return (cursorX - 10 - treeWidth - offsetLeft) + "px";
    } else {
        return (cursorX - menuElm.offsetWidth + 10 - treeWidth - offsetLeft) + "px";
    }
}

/**
 * @param menuElm The menuElm.offsetHeight controls whether or not the click menu will open up as from
 * the click position down or click position up.
 * @param containerHeight
 * @param scrollTop
 * @param cursorY
 * @param barHeight
 * @param firstRowOffsetHeight
 * @returns {string}
 */
export function calculateTopPosition(menuElm, containerHeight, scrollTop, cursorY, barHeight, firstRowOffsetHeight) {
    const menuHeight = menuElm.offsetHeight;

    const isTopHalfOfMenuClicked = () => {
        return (cursorY - scrollTop) < (containerHeight / 2) + menuHeight - 200;
    };

    const getInitialPosition = () => {
        if (isTopHalfOfMenuClicked()) {
            return cursorY - (firstRowOffsetHeight / 2) - barHeight;
        } else {
            return (cursorY - menuHeight + (firstRowOffsetHeight / 2)) - barHeight;
        }
    };

    const isPositionedTooHigh = (position) => {
        return (position + menuHeight) > scrollTop + containerHeight - barHeight;
    };

    const isPositionedTooLow = (position) => {
        return position < (scrollTop - barHeight + 200);
    };

    let position = getInitialPosition();
    if (isTopHalfOfMenuClicked() && isPositionedTooHigh(position)) {
        while (isPositionedTooHigh(position)) {
            position--;
        }
    } else if (!isTopHalfOfMenuClicked() && isPositionedTooLow(position)) {
        while (isPositionedTooLow(position)) {
            position++;
        }
    }

    return position + "px";
}

/*
 Get a containers width or height in a browser independent way.
 Algorithm from http://www.howtocreate.co.uk/
 */
export function getContainerSize() {
    let width = 0;
    let height = 0;

    if (typeof window.innerWidth == "number") {
        // Non-IE
        width = window.innerWidth;
        height = window.innerHeight;
    } else if (
        document.documentElement &&
        (document.documentElement.clientWidth ||
            document.documentElement.clientHeight)
    ) {
        // IE 6+ in 'standards compliant mode'
        width = document.documentElement.clientWidth;
        height = document.documentElement.clientHeight;
    } else if (
        document.body &&
        (document.body.clientWidth || document.body.clientHeight)
    ) {
        // IE 4 compatible
        width = document.body.clientWidth;
        height = document.body.clientHeight;
    }

    return [width, height];
}

export function CA_getContainerWidth() {
    return getContainerSize()[0];
}

export function CA_getContainerHeight() {
    return getContainerSize()[1];
}

/*
 Called by the parent and, (for legacy pages), the child iframe when a body onresize event occurs.
 @param caller tells which document is resizing, either 'PARENT' or 'CHILD-IFRAME'.

 The child area (iframe or not) can optionally have a fixed-height/unscrolled area
 with an id of "unscrolledChildContent"
 */
export function updateParentChildSize(caller) {
    let windowInnerH = getContainerSize()[1];
    let topBarH = 108; // constant must match top bar height + toolbar height (div.nav-container + div.body-header)

    // compute the sizes
    let treeH = windowInnerH - topBarH - 35;
    let iframeH = windowInnerH - topBarH - 10;
    let mapFrameH = windowInnerH - topBarH - 30; // more is subtracted below

    // if there are buttons then account for them.

    if (document.getElementById("actionArea")) {
        let buttons = document.getElementById("actionArea").clientHeight;
        treeH = treeH - buttons;
        iframeH = iframeH - buttons;
        mapFrameH = mapFrameH - buttons;
    }

    // have a child iframe?
    let iframe = document.getElementById("contentarea");
    if (iframe) {
        // resize the child iframe
        iframe.style.height = iframeH + "px";
    }
}

/*get the dimensions of the client viewport (the part of the window actually showing the page).
  This is an estimate so expect +/- 20 pixels.
*/
export function getRoughInnerWindowSize() {
    let myWidth = 0, myHeight = 0;
    if (typeof( window.innerWidth ) == 'number') {
        myWidth = window.innerWidth;
        myHeight = window.innerHeight;
    }
    return [myWidth, myHeight];
}

export function keepElementSized(elmId, offsetHeight, minHeight) {
    this.elmId = elmId;
    this.offsetHeight = offsetHeight;
    this.minHeight = minHeight;
    this.checkResize = function() {
        let wHeight = document.documentElement.clientHeight;

        // as long as we are resizing the element with a page size of its offset height
        // plus its minimum height, perform the resize
        if (wHeight > (this.offsetHeight + this.minHeight)) {
            wHeight = wHeight - (this.offsetHeight + this.minHeight);

            document.getElementById(elmId).style.height=wHeight + "px";
        }
    }

    this.checkResize();
    window.onresize=this.checkResize;
}

/**
 * Opens a new window of the specified URL and automatically displays window print prompt.
 * @param url
 * @param windowFeatures
 */
export function openPrintWindow(url, windowFeatures) {
    if (!url) {
        console.error('openPrintWindow() failed, URL is invalid...');
        return;
    }

    const defaultFeatures = 'height=400,width=600,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes';
    const features = windowFeatures ? windowFeatures : defaultFeatures;

    const printWindow = window.open(url, 'PRINT', features);
    printWindow.addEventListener('load', function() {
        printWindow.print();
    }, false);

    printWindow.focus();
    return true;
}